'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../../core/translator');
const FormBuilder = require('./../../builder');

const tplColorElement = require('./template/color_panel_element.hbs');
const tplColorPanelContainer = require('./template/color_panel_container.hbs');

let ElementClass = require('./../../elementClass');

FormBuilder.register('colorPanelElement', function(config) {
  let self = new ElementClass(config);
  let $container;

  const onDelete = function($wrapper) {
    $wrapper[0].title === '' ? $wrapper.attr('title', Translator.translate('color_undo_title')) : $wrapper.removeAttr('title');
    $wrapper.toggleClass('color-removed');
    $wrapper.find('.overlay-undo').toggleClass('d-none');
  };

  const bindAddEvent = function() {
    let $tplAddBtn = $container.find('.color-add-new');
    let $inputElement = $tplAddBtn.find('.color-panel-element');

    $inputElement.spectrum({
      'allowEmpty': true,
      'showInput': true,
      'preferredFormat': 'hex',
      'clickoutFiresChange': false,
      'chooseText': Translator.translate('choose'),
      'cancelText': Translator.translate('cancel'),
      'hide': function(color) {
        if (color) {
          $inputElement.spectrum('set', '');
          self.addItem({'color': color.toHexString()});
        }
      },
    });

    $tplAddBtn.find('.sp-replacer').append('<span class="add-color-text">' + Translator.translate('color_add') + '</span>');
  };

  self.addItem = function(color) {
    let $colorElement = jQuery(tplColorElement({
      'label': self.config.label,
      'value': color.color,
      'id': color.id,
      'disabled': self.config.disabled,
      'isDeletable': self.config.isDeletable,
    }));

    $colorElement.find('.color-panel-element').spectrum({
      'showInput': true,
      'preferredFormat': 'hex',
      'chooseText': Translator.translate('choose'),
      'cancelText': Translator.translate('cancel'),
      'change': function(color) {
        jQuery(this).attr('value', color.toHexString());
      },
    });

    let $groupCustomColors = $container.find('.group.custom-colors');
    self.config.label ? $container.find('.group.theme-colors').append($colorElement) : $groupCustomColors.find('.color-add-new').after($colorElement);

    if (self.config.isDeletable) {
      $colorElement.find('.color-overlay-undo, .color-remove-btn').on('click', function() {
        onDelete($colorElement);
      });
    }
  };

  self.render = function() {
    $container = jQuery(tplColorPanelContainer({
      'addColor': self.config.addColor,
    }));
    self.config.value.forEach(self.addItem);

    if ($container.find('.color-add-new').length === 1) {
      bindAddEvent();
    }

    return $container;
  };

  self.getData = function() {
    let $colorWrapper = $container.find('.group.theme-colors, .group.custom-colors');
    let $colors = $colorWrapper.find('.color-element-wrapper').not('.color-removed');
    let colorItems = [];

    $colors.each(function(item) {
      let $current = jQuery($colors[item]).find('.color-panel-element');

      if ($current.data('id')) {
        colorItems.push({
          'id': $current.data('id'),
          'color': $current.val(),
        });
      } else {
        colorItems.push({'color': $current.val()});
      }
    });

    return colorItems;
  };

  return self;
});
